import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, mediaUrl } from "@/lib/api";
import { useSite } from "@/context/SiteContext";
import { Input } from "@/components/ui/input";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { settings } = useSite();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("rdx_admin_token", data.token);
      navigate("/admin");
    } catch (err) {
      toast.error(errMsg(err, "No se pudo iniciar sesión"));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm bg-white rounded-2xl shadow-lg p-8 fade-up">
        {settings?.logo_url && <img src={mediaUrl(settings.logo_url)} alt="logo" className="h-20 mx-auto object-contain" />}
        <h1 className="text-2xl font-bold text-center mt-4">Panel de Administración</h1>
        <p className="text-sm text-gray-500 text-center mt-1">Ingresa tus credenciales</p>
        <div className="space-y-4 mt-6">
          <div><label className="text-sm font-medium">Correo</label><Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5" data-testid="admin-email-input" /></div>
          <div><label className="text-sm font-medium">Contraseña</label><Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5" data-testid="admin-password-input" /></div>
        </div>
        <button disabled={loading} className="btn-brand w-full h-11 rounded-md font-semibold mt-6 flex items-center justify-center gap-2 disabled:opacity-60" data-testid="admin-login-btn">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Lock className="w-4 h-4" />}Entrar
        </button>
        <a href="/" className="block text-center text-sm text-gray-500 hover:text-[var(--brand)] mt-4">← Volver al sitio</a>
      </form>
    </div>
  );
}
